/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AdminInfoResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'Admin',
        isRequired: true,
      },
    },
  }],
} as const;
